export const parseToHTML = (data: (string | { tag: string })[]): string => {
  let parsed = ''
  data.forEach((d) => {
    if (typeof d === 'object' && !!d.tag) parsed += `<${d.tag}/>`
    else if (typeof d === 'string') parsed += d
  })
  return parsed
}
